import React, { Fragment, useState } from "react"

import ServiceItem from "../ServiceItem"
import AlertModalWithBody from "../../../ui-components/AlertModalWithBody.jsx"
import ItemPrice from "../../../ui-components/ItemPrice"
import EMPTY_LOGO from "../../../../../assets/images/landings/empty-cart.svg"

import style from "./ServicesCart.module.scss"

export default function ServicesCart(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const {
    cart,
    minDeliveryPrice,
    maxDeliveryPrice,
    onIncreaseQuantityClicked,
    onDecreaseQuantityClicked,
    isTakeawayActive,
    editable = true,
  } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  const [isDeliveryModalVisible, setIsDeliveryModalVisible] = useState(false)

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function showDeliveryModal() {
    setIsDeliveryModalVisible(true)
  }

  function hideDeliveryModal() {
    setIsDeliveryModalVisible(false)
  }

  function renderDeliveryPriceDetails() {
    if (minDeliveryPrice === null) {
      return (
        <span className={style.caption}>{I18n.t("delivery_terminated")}</span>
      )
    } else if (minDeliveryPrice !== maxDeliveryPrice) {
      return (
        <div className={`${style.subtotalPrice} ${style.from}`}>
          {I18n.t("delivery_prep")}{" "}
          {maxDeliveryPrice === 0 ? (
            <span>{I18n.t("delivery_choose_time")}</span>
          ) : (
            <ItemPrice
              className={`${style.subtotalPrice} ml-2`}
              priceCents={minDeliveryPrice}
            />
          )}
        </div>
      )
    } else if (maxDeliveryPrice === 0) {
      return (
        <span className={style.caption}>{I18n.t("delivery_choose_time")}</span>
      )
    } else {
      return (
        <ItemPrice
          className={style.subtotalPrice}
          priceCents={minDeliveryPrice}
        />
      )
    }
  }

  function renderCostElement(minDeliveryPrice, maxDeliveryPrice) {
    const { total = 0, subtotal = 0, original_subtotal } = cart

    return (
      <div className={style.costsContainer}>
        <div className={`${style.subtotalContainer} mt-3`}>
          <span className={style.caption}>{I18n.t("menu_total")}</span>
          <ItemPrice
            className={style.subtotalPrice}
            originalPriceCents={original_subtotal}
            priceCents={subtotal}
          />
        </div>
        {Object.keys(cart.coupons || {}).map(function (coupon_code, i) {
          const coupon = cart.coupons[coupon_code]

          return (
            <div key={i} className={`${style.subtotalContainer} mt-3`}>
              <span className={style.caption}> Coupon {coupon.code}</span>
              <ItemPrice
                className={`${style.subtotalPrice} ml-3`}
                priceCents={-coupon.amount}
              />
            </div>
          )
        })}
        {!isTakeawayActive && (
          <div className={`${style.subtotalContainer} my-2`}>
            <span className={style.caption}>{I18n.t("delivery")}</span>
            {renderDeliveryPriceDetails()}
          </div>
        )}

        {maxDeliveryPrice > 0 && (
          <div className={style.deliveryModalTrigger}>
            <a onClick={showDeliveryModal}>
              {I18n.t("delivery_from_desc_why", {
                price: (minDeliveryPrice / 100).toFixed(2),
              })}
            </a>
          </div>
        )}
        {editable && (
          <div className={`${style.subtotalContainer} mt-3`}>
            <span className={style.caption}>{I18n.t("total")}</span>
            <ItemPrice
              className={`${style.subtotalPrice} ml-3`}
              priceCents={total}
            />
          </div>
        )}
        {!editable && maxDeliveryPrice > 0 && (
          <div className={`${style.totalContainer} mt-3`}>
            <span className={style.total}>{I18n.t("total")}</span>
            <ItemPrice className={`${style.total} ml-3`} priceCents={total} />
          </div>
        )}
        {!editable && maxDeliveryPrice > 0 && !!cart.discount_amount && (
          <div className={style.totalDiscountDesc}>
            {I18n.t("total_discount_desc", {
              discount_amount: ((original_subtotal - subtotal) / 100).toFixed(
                2
              ),
              percentage: cart.promotion?.percentage,
            })}
          </div>
        )}
      </div>
    )
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  const services = cart.products || {}
  let servicesKeys = Object.keys(services)

  // -------------------------------------

  return (
    <Fragment>
      {servicesKeys.length === 0 && (
        <div className={style.emptyCartContainer}>
          <img className={style.emptyCartImage} src={EMPTY_LOGO} alt="empty" />
          <p className={`mt-3 mb-0 text-left small ${style.emptyCartTitle}`}>
            {I18n.t("service_ordering.cart_empty")}
          </p>
        </div>
      )}

      {servicesKeys.length !== 0 && (
        <Fragment>
          <div className={style.sectionCartContainer}>
            {servicesKeys.reverse().map((service_key) => {
              const service = services[service_key]

              return (
                <ServiceItem
                  key={service_key}
                  service={service}
                  service_key={service_key}
                  onIncreaseQuantity={onIncreaseQuantityClicked}
                  onDecreaseQuantity={onDecreaseQuantityClicked}
                  editable={editable}
                />
              )
            })}
          </div>

          {renderCostElement(minDeliveryPrice, maxDeliveryPrice)}
        </Fragment>
      )}

      <AlertModalWithBody
        show={isDeliveryModalVisible}
        onHide={hideDeliveryModal}
        onConfirm={hideDeliveryModal}
        title={I18n.t("delivery_modal.title", {
          price: (minDeliveryPrice / 100).toFixed(2),
        })}
        closeLabel={I18n.t("delivery_modal.close")}
        shadow
      >
        <div className="boy-image"></div>
        <p>{I18n.t("delivery_modal.body_1")}</p>
        <p style={{ fontWeight: 400 }}>{I18n.t("delivery_modal.body_2")}</p>
        <p>{I18n.t("delivery_modal.body_3")}</p>
      </AlertModalWithBody>
    </Fragment>
  )
}
